import { render, staticRenderFns } from "./subjectDetail.vue?vue&type=template&id=1f8a91a4&scoped=true"
import script from "./subjectDetail.vue?vue&type=script&lang=js"
export * from "./subjectDetail.vue?vue&type=script&lang=js"
import style0 from "./subjectDetail.vue?vue&type=style&index=0&id=1f8a91a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8a91a4",
  null
  
)

export default component.exports